import React from "react"
import {Grid} from "@mui/material";
import {CmCollection, CmTeasable} from "../../../../packages/graphql-layer/src";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import C021KachelTeaserCard from "./C021KachelTeaserCard";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import useWindowSize from "../../../utility/useWindowSize";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import {RichTextElement} from "../../fundamentals/CCORichText/CCORichTextHelper";


export interface Props {
    cmCollection: CmCollection
    useSquareImage?: boolean
    headline?: string
}

function C021KachelTeaser(props: Props) {
    const {greaterThanWindowMedium} = useWindowSize()
    const shouldUseResponsiveFontSize = (props.cmCollection.viewtype === 'adaptiveCrosslink' || props.cmCollection.viewtype === 'c021_kachel_teaser')
        && props.cmCollection.items!.length >= 3;
    return  <CCOComponentWrapper>
        <CCOHeadline metadataId={props.cmCollection.id} id={props.cmCollection.id}
                     type={"componenthead"}
                     headline={props.headline? props.headline : props.cmCollection.teaserTitle}
                     propertyName={props.headline? 'properties.headline' : 'properties.teaserTitle'}
        />
        <CCOContainer>
            <CCORichText metadataId={props.cmCollection.id} textAsTree={props.cmCollection.teaserText?.textAsTree as RichTextElement}/>
        </CCOContainer>
        <CCOContainer  width={"large"}><>
            <Grid container justifyContent={"center"} spacing={6}>
                {props.cmCollection.items ? props.cmCollection.items?.map(i => i as CmTeasable).map((i: any, index: number) => {
                    return  <Grid item key={index}  md={props.cmCollection.items!.length === 1 ? 12 : (props.cmCollection.items!.length === 2 ? 6 : 4)}
                                  sm={12} xs={12} display={'flex'} alignItems={'stretch'} >
                        <C021KachelTeaserCard useSquareImage={props.useSquareImage}
                                              item={i}
                                              teaser={true}
                                              orientation={props.cmCollection.items!.length === 1 && greaterThanWindowMedium ? "landscape_ratio20x7" : "portrait_ratio1x1"}
                                              customStyle={{paddingX: '0!important'}}
                                              shouldUseResponsiveFontSize={shouldUseResponsiveFontSize}
                        />
                    </Grid>

                }): null
                }
            </Grid></>
        </CCOContainer></CCOComponentWrapper>
}

export default C021KachelTeaser